<script setup>
    import config from "@/config";
    const URL = config.base_url.replace("/adminapi","");
    
    const props = defineProps({
        data: {
            type: [Object,Array],
            default: {}
        }
    })
    
    const getImage = (value)=>{
        if(value != undefined){
          return value.image;
        }

        return URL + '/static/images/menu/empty.png';
    }
    
    const customStyle = ref({});
    const defaultStyle = ()=>{
      customStyle.value = {};
      customStyle.value.backgroundColor         = props.data.background_color;
      customStyle.value.borderTopLeftRadius     = props.data.radiusLT + 'px';
      customStyle.value.borderTopRightRadius    = props.data.radiusRT + 'px';
      customStyle.value.borderBottomLeftRadius  = props.data.radiusLB + 'px';
      customStyle.value.borderBottomRightRadius = props.data.radiusRB + 'px';
      customStyle.value.width                   = (100 - props.data.marginLR) + '%';
      customStyle.value.marginLeft              = "auto";
      customStyle.value.marginRight             = "auto";
      customStyle.value.marginTop               = props.data.marginTB + "px";
      customStyle.value.marginBottom            = props.data.marginTB + "px";
      customStyle.value.overflow                = 'hidden';
    }

    defaultStyle();
    watch([()=>props.data.marginTB,()=>props.data.marginLR,()=>props.data.radiusLT,()=>props.data.radiusRT,()=>props.data.radiusLB,()=>props.data.radiusRB,()=>props.data.background_color],(newValue,oldValue)=>{
      defaultStyle();
    });
    
</script>

<template>
  <div class="text">
    <div :style="customStyle">
      <div v-html="props.data.content || ''"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.text {
  
}
</style>